// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioMute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.06 18.12c-.07.042-.14.082-.212.12a4.14 4.14 0 0 1-1.336.46c-.273.04-.498-.186-.498-.463v-.5c0-.198.117-.368.281-.474a.723.723 0 0 1 .213-.093 2.73 2.73 0 0 0 .443-.159L14 14.061V19c0 .866-1.025 1.323-1.669.743L8.73 16.257A1 1 0 0 0 8.06 16H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.44L3.822 3.884a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0l4.391 4.392.001-.001 1.054 1.054 2.17 2.171v-.002l1.5 1.5v.002l2.014 2.015v-.002l.774.773-.001.001 1.389 1.39v-.002l1.061 1.06v.002l1.94 1.94a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0zm-5.56-5.56L9.176 9.238a2.5 2.5 0 0 1-1.115.263H5.5v5h2.56a2.5 2.5 0 0 1 1.673.642l2.767 2.735z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.5 8.116V6.123l-1.002.99-1.042-1.04 1.875-1.816c.644-.58 1.67-.123 1.67.743v4.616zM21.265 11.987a7.646 7.646 0 0 1-1.028 3.865l-1.107-1.106c.39-.784.635-1.72.635-2.759 0-1.57-.56-2.902-1.33-3.835l-.01-.014c-.425-.512-.891-.88-1.341-1.11a2.833 2.833 0 0 0-.603-.231.734.734 0 0 1-.185-.085.572.572 0 0 1-.281-.475v-.5c0-.276.225-.503.498-.462a4.14 4.14 0 0 1 1.337.46 5.953 5.953 0 0 1 1.744 1.463c.981 1.192 1.67 2.86 1.67 4.79z"
    />
    <path
      fill="currentColor"
      d="M16.015 11.63V9.488c0-.276.231-.504.485-.397.202.086.396.22.575.397a2.685 2.685 0 0 1 .44.576c.304.52.5 1.192.5 1.924 0 .504-.093.978-.25 1.395z"
    />
  </svg>
);
export default SvgMediaAudioMute;
